var _path, _path2, _ellipse;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    id: "Calque_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 224.8 178",
    style: {
      "enableBackground": "new 0 0 224.8 178"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.4,62.5c10.5-11,44-35,88-35s77.5,24,88,35c5.5,5.5,14,6,20,0.5c5.5-5,6-14,0.5-19.5 C206.4,28.5,165.9,0,112.4,0S18.4,28.5,3.9,43.5C-1.6,49-1.1,58,4.4,63C9.9,68.5,18.9,68.5,24.4,62.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.9,105c8-7,23-19.5,47-19.5c23.5,0,39,12.5,47,19.5c5.5,5,14.5,4.5,20-1c5-5.5,5-14.5-1-19.5 c-9.5-8.5-31-26.5-65.5-26.5S56.9,76.5,47.9,84.5c-5.5,5-6,14-1,19.5C51.4,109.5,60.4,110,65.9,105z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 112.4,
    cy: 150,
    rx: 28.5,
    ry: 28
  })));
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNS40LjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FscXVlXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgMjI0LjggMTc4IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyMjQuOCAxNzg7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiNGRkZGRkY7fQ0KPC9zdHlsZT4NCjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0yNC40LDYyLjVjMTAuNS0xMSw0NC0zNSw4OC0zNXM3Ny41LDI0LDg4LDM1YzUuNSw1LjUsMTQsNiwyMCwwLjVjNS41LTUsNi0xNCwwLjUtMTkuNQ0KCUMyMDYuNCwyOC41LDE2NS45LDAsMTEyLjQsMFMxOC40LDI4LjUsMy45LDQzLjVDLTEuNiw0OS0xLjEsNTgsNC40LDYzQzkuOSw2OC41LDE4LjksNjguNSwyNC40LDYyLjV6Ii8+DQo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNjUuOSwxMDVjOC03LDIzLTE5LjUsNDctMTkuNWMyMy41LDAsMzksMTIuNSw0NywxOS41YzUuNSw1LDE0LjUsNC41LDIwLTFjNS01LjUsNS0xNC41LTEtMTkuNQ0KCWMtOS41LTguNS0zMS0yNi41LTY1LjUtMjYuNVM1Ni45LDc2LjUsNDcuOSw4NC41Yy01LjUsNS02LDE0LTEsMTkuNUM1MS40LDEwOS41LDYwLjQsMTEwLDY1LjksMTA1eiIvPg0KPGVsbGlwc2UgY2xhc3M9InN0MCIgY3g9IjExMi40IiBjeT0iMTUwIiByeD0iMjguNSIgcnk9IjI4Ii8+DQo8L3N2Zz4NCg==";
export { SvgComponent as ReactComponent };